import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import type { TooltipPosition } from '@angular/material/tooltip';
import { SubscriptSizing } from '@angular/material/form-field';

@Component({
  selector: 'app-text-input',
  templateUrl: './text-input.component.html',
  styleUrls: ['./text-input.component.scss'],
  standalone: false
})
export class TextInputComponent {
  @Input() inputType: string;
  @Input() inputControl: FormControl<string>;
  @Input() disabled: boolean;
  @Input() readOnly: boolean;
  @Input() required: boolean;
  @Input() labelTextId: string;
  @Input() propertyKey: string;
  @Input() tooltipTextId: string;
  @Input() tooltipPosition: TooltipPosition;
  @Input() placeholder: string;
  @Input() showLengthCounter: boolean;
  @Input() subscriptSizing: SubscriptSizing;

  @Output() focusChange: EventEmitter<boolean>;

  constructor() {
    this.focusChange = new EventEmitter();
  }

  protected getMaxLength(): number {
    return this.inputControl.errors && this.inputControl.errors['minlength'] && this.inputControl.errors['minlength']['requiredLength'];
  }

  protected getCurrentLength(): number {
    return this.inputControl.value?.length || 0;
  }
}
